<script>
import _ from 'lodash';
import Vue from 'vue';

export default {
  name: 'BoardMethodMixin',
  methods: {
    collapseAllDetailRows() {
      if (_.isEmpty(this.$refs.vuetable)) return;
      this.$refs.vuetable.visibleDetailRows = [];
    },

    visibleDetailRowCount() {
      return this.$refs.vuetable.visibleDetailRows.length;
    },

    isOpenDetailRow(id) {
      const visibleList = this.$refs.vuetable.visibleDetailRows;

      return !(visibleList.findIndex(idx => id === idx) === -1);
    },

    openInsertDetailRow(id) {
      this.$refs.vuetable.toggleDetailRow(id);
    },

    scrollReset() {
      const container = this.$el.querySelector('.overflow-table');
      container.scrollLeft = 0;
    },

    updateField() {
      if (_.isEmpty(this.$refs.vuetable)) return;

      Vue.nextTick(() => {
        this.$refs.vuetable.normalizeFields();
        // this.$refs.vuetable.refresh();
        this.$refs.vuetable.reload();
      });
    },

    toggleDetailRow(id) {
      this.$refs.vuetable.toggleDetailRow(id);
      this.scrollReset();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/table/components/mixins/BoardMethodMixin.vue